exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "/* ---------- COLORS ----------*/\ndiv.xsColorPicker div.xs-label {\n  color: #78849e;\n  font-size: 9pt;\n  line-height: 19px;\n}\n", ""]);

// exports
